module.exports = __webpack_public_path__ + "static/example-d2368ba056e728ffd00b60214d0c4ea8.png";